module.exports = __webpack_public_path__ + "static/media/femaleTwigs.e4e43aab.svg";